export const notificationConstants = {
    oneTimeScheduleType: "scheduleOneTime",
    repeatScheduleType: "scheduleTypeRepeat",

    iosPlatform: "iosPlatform",
    androidPlatform: "androidPlatform",
    notifySeverityInfo: "info",
    notifySeverityAlert: "alert",
    notifySeverityRecommendation: "recommendation",
    notifySeverityPromotion: "promotion",
    emailNotificationPriorityNormal: "NORMAL",

}
export const pushNotificationChannelTypes = {
    pushNotification: { value: "push", label: "Push Notification" },
}

export const notificationChannelTypes = {
    ...pushNotificationChannelTypes,
    // smsNotification: { value: "sms", label: "SMS Notification" },
    emailNotification: { value: "email", label: "E-mail Notification" },
}

export const emailUserTargetTypes = {
    broadcast: { value: "broadcast", label: "Broadcast" },
    targeted: { value: "targeted", label: "Targeted" },
}

export const pushUserTargetTypes = {
    broadcast: { value: "broadcast", label: "Broadcast" },
    userSpecific: { value: "user-specific", label: "User-specific" },
}

export const PUSH_TYPE_CATEGORY_MAP = {
    ALERT: [
        "DynamicNotification",
    ],
}

export const pushNotificationTypeOptions = Object.keys(PUSH_TYPE_CATEGORY_MAP).map(
    (type) => ({ value: type, label: type })
)

export const getPushCategoryOptionsForType = (type) => {
    const categories = PUSH_TYPE_CATEGORY_MAP[type] || []
    return categories.map((category) => ({ value: category, label: category }))
}

export const PUSH_MAX_CTAS = 2

export const PUSH_SELECT_ALL_COUNTRIES = "__ALL__";

export const EMPTY_PUSH_CTA = { label: "", target: "" }

export const PUSH_TARGET_SCREEN_PREFIX = "miraie://";

export const DEFAULT_PUSH_TARGET_SCREEN = `${PUSH_TARGET_SCREEN_PREFIX}dashboard`;

export const PUSH_TARGET_SCREEN_EXAMPLES = [
  {
    label: "Dashboard",
    value: `${PUSH_TARGET_SCREEN_PREFIX}dashboard`,
  },
  {
    label: "Lifestyle",
    value: `${PUSH_TARGET_SCREEN_PREFIX}dashboard?tab=lifestyle`,
  },
  {
    label: "D2C",
    value: `${PUSH_TARGET_SCREEN_PREFIX}webview?url=https://store.in.panasonic.com`,
    hint: "Panasonic store — discover home appliances including ACs, refrigerators, washing machines, water purifiers and more.",
  },
  {
    label: "Ultron portal",
    value: `${PUSH_TARGET_SCREEN_PREFIX}webview?authenticatedUrl=https://ultron.lifestylecommerce.in`,
  },
  {
    label: "Other URL",
    value: `${PUSH_TARGET_SCREEN_PREFIX}webview?externalUrl=https://www.google.com/`,
  },
]

export const createEmptyPushMessageForm = () => ({
    type: "",
    category: "",
    title: "",
    description: "",
    targetScreen: "",
    image: "",
    ctas: [],
})

export const notificationValidations = {
    email: {
        subject: { maxLength: 200 },
    },
    push: {
        body: { maxLength: 1000 },
        title: { maxLength: 100 },
        ctaLabel: { maxLength: 20 },
        ctaTarget: { maxLength: 500 },
        targetScreen: { maxLength: 500 },
    },
    sms: {
        body: { maxLength: 200 }
    }
}

export const notificationDetailsRefreshRate = 10000;

export const notificationStatusHeaders = {
    taskId: { label: "Task Id" },
    expectedUserCount: { label: "Total User Count" },
    userCount: { label: "Success User Count" },
    // successCount: "Success Count",
    failureCount: { label: "Failure Count" },
    taskStatus: { label: "Task Status" },
    action: { label: "Actions", style: { display: 'flex', justifyContent: "flex-start" } }
};

export const notificationStatusMoreHeaders = {
    notificationType: { label: "Type" },
    severity: { label: "Severity" },
    createdAt: { label: "Created At" },
    expiryDate: { label: "Expiry" },
};

export const notificationListPageSize = 20;
export const notificationListPageSizeOptions = [20, 50, 100];

export const getNotificationPermission = (userRoles, operation, type = "role", userLevel) => {
    const roleBasedpermissions = {
        sendNotification: userRoles?.includes("CUSTOMERSUPPORTL3") || userRoles?.includes("CUSTOMERSUPPORTL3SPECIAL") || userRoles?.includes("CUSTOMERSUPPORTL4") || userRoles?.includes("CLOUDADMIN"),
        getNotificationList: userRoles?.includes('CUSTOMERSUPPORTL4') || userRoles?.includes('CLOUDADMIN') || userRoles?.includes('SYSTEM_PUSH_NOTIFICATION'),
        getNotificationTask: userRoles?.includes('CUSTOMERSUPPORTL2') || userRoles?.includes('CUSTOMERSUPPORTL3') || userRoles?.includes('CUSTOMERSUPPORTL4') || userRoles?.includes('CLOUDADMIN') || userRoles?.includes('CUSTOMERSUPPORTL3SPECIAL'),
        cancelNotification: userRoles?.includes("CUSTOMERSUPPORTL2") || userRoles?.includes("CUSTOMERSUPPORTL3") || userRoles?.includes("CUSTOMERSUPPORTL4") || userRoles?.includes("CLOUDADMIN") || userRoles?.includes("CUSTOMERSUPPORTL3SPECIAL")
    }
    const levelBasedPermissions = {
        userCountrySelection: userLevel >= 4,
        userLoginSelection: userLevel >= 4,
        userCategorySelection: userLevel >= 4
    }
    return type === 'level' ? levelBasedPermissions?.hasOwnProperty(operation) ? levelBasedPermissions[operation] : false : roleBasedpermissions?.hasOwnProperty(operation) ? roleBasedpermissions[operation] : false
}

export const showBroadcastCountryAlert = (countryNames) => {
  const names = (Array.isArray(countryNames) ? countryNames : [countryNames])
    .map((name) => String(name || "").trim())
    .filter(Boolean);

  if (!names.length) return false;

  if (names.length === 1) {
    return window.confirm(
      `This Broadcast notification will be sent to all MirAie users of ${names[0]}.`
    );
  }

  return window.confirm(
    `This Broadcast notification will be sent to all MirAie users of: ${names.join(", ")}.`
  );
}

export const showEmailBroadcastConfirm = () =>
    window.confirm("This email notification will be sent to all mobile users.");